// Your activity (02-DESIGN/03-console/01-the-console.md § the shape: a
// member's own sign-in records are under the person's menu; the workspace's
// are under Audit & usage). A row opens the record's page, `me/activity/<id>`
// (RecordPage.tsx).

import { PageHead } from "../../ui/components.tsx";
import { SignInRecords } from "../records/SignInRecords.tsx";
import { useSurface } from "../surface.tsx";

export function ActivityPage() {
  const s = useSurface();
  return (
    <>
      <PageHead title="Your activity" line={`Your sign-ins to ${s.name}.`} />
      <SignInRecords mine={s.me} />
    </>
  );
}
